import axios from 'axios'
axios.defaults.headers.common['Accept'] = 'application/json'

export default {
    getRoles({ rootState, commit }) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true)
            axios
                .get(`${rootState.baseURL}/roles`)
                .then(({ data }) => {
                    commit('setRoles', data.roles)
                    commit('setLoading', false)
                    resolve(data.roles)
                })
                .catch((error) => {
                    commit('setLoading', false)
                    reject(error)
                })
        })
    },
    getDefaults({ rootState, commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/roles/defaults`)
                .then(({ data }) => {
                    commit('setDefaults', data.roles)
                    resolve(data.roles)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    updateRolePermissions({ rootState, commit }, { roleId, permissions }) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/roles/${roleId}/permissions`, { permissions })
                .then(({ data }) => {
                    commit('updateRolePermissions', { roleId, permissions })
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    updateBulkPermissions({ rootState, commit }, roles) {
        return new Promise((resolve, reject) => {
            axios
                .put(`${rootState.baseURL}/roles/permissions`, { roles })
                .then(({ data }) => {
                    Object.entries(roles).forEach(([roleId, perms]) => {
                        Object.entries(perms).forEach(([perm, enabled]) => {
                            commit('updateRolePermission', { roleId: Number(roleId), perm, enabled })
                        })
                    })
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
